// src/ConsumerApp/api/payment/payment.service.js
import { apiClient } from '../apiClient';

export const PaymentService = {
  initiatePayment: async (payload) => {
    const response = await apiClient.post('/brickbucket/payments/initiate-payement-process', {
      amount: payload.amount,
      customerId: payload.customerId || payload.customer_id,
      hubId: payload.hubId,
      projectId: payload.projectId,
      bucketId: payload.bucketId || payload.bucket_id,
      paymentMethod: payload.paymentMethod || payload.payment_mode,
      payment_method: payload.paymentMethod || payload.payment_mode,
      selected_delivery_type: payload.selected_delivery_type,
      delivery_type: payload.delivery_type,
      pricing_token: payload.pricing_token,
      purchase_mode:payload.purchase_mode,
      rfq_id:payload.rfq_id,
    });
    return response;
  },

  verifyPaymentStatus: async (payload) => {
    const response = await apiClient.post('/brickbucket/payments/verify-status', {
      order_id: payload.order_id,
      customer_id: payload.customer_id,
    });
    return response;
  },

  getOrderByTransactionId: async (payload) => {
    const response = await apiClient.get(`/brickbucket/payments/get-order-by-transaction-order-id?transaction_order_id=${payload.transaction_order_id}`);
    return response;
  },
};